import { jsx as _jsx } from "react/jsx-runtime";
import { AuthButton } from "./auth-button.js";
import { useAuthButtonProps, } from "../hooks/public/use-auth-button-props.js";
export const SignIn = ({ buttonProps = {}, onError, onSuccess, onSignOut, scopes, variant = 'light', }) => {
    const { loading, onClick, signedIn } = useAuthButtonProps({
        onError,
        onSignOut,
        onSuccess,
        scopes,
    });
    return (_jsx(AuthButton, { variant: variant, signedIn: signedIn, loading: loading, ...buttonProps, onClick: onClick }));
};
//# sourceMappingURL=sign-in.js.map